<template>
  <div class="container logo-component col-12 w-100">
    <router-link  tag="a" to="/" ><div class="logo-text" :style="logoStyle" v-html="title_text_show"></div></router-link>
  </div>
</template>

<script>
import {eventBus} from "@/main";
import Vue from "vue";

export default {
  name: "LogoComponent",
  props: {
    nameSite: {
      type: String,
      required: true
    },
    slogans:{
      type:Array,
      required:true,
    }
  },
  data() {
    return {
      colors: ["#0055FF", "#00FF55", "#FF5500"],
      available_words:[],


      currentColorIndex: 0,
      current_theme:null,
      animation: null,
      title_text:null,
      title_text_show:null,
      animate_mounted:null,
      animation_interval:null,
      animate_change_colors_text:null,
      logoStyle: {},
      theme_data:{},
      prev_animation_name:null,
    };
  },
  mounted() {


   //
   // this.available_words=["вместе делаем","добро","специалисты","для вас"]
    this.available_words=this.slogans;
    this.title_text=this.nameSite;
    this.available_words.push(this.nameSite);
    this.title_text_show=this.nameSite;
    this.current_theme='day_mode';
    if(localStorage.getItem("theme_mode")){
      this.current_theme=localStorage.getItem("theme_mode");
    }
    this.startAnimation();

    var app=this;
    eventBus.$on("theme_is_changed",data=>{
      var theme=data.theme;

      app.current_theme=theme;
      try{
        clearInterval(app.animate_mounted);
        clearInterval(app.animation_interval);
      }catch(err){

      }

      this.startAnimation();

    });
   },
  methods: {
    hexToRgb(hex) {
  const r = parseInt(hex.substring(1, 3), 16);
  const g = parseInt(hex.substring(3, 5), 16);
  const b = parseInt(hex.substring(5, 7), 16);
  return [r, g, b];
},

    rgbToHex(r, g, b) {
      return (
          "#" +
          [r, g, b]
              .map((x) => {
                const hex = x.toString(16);
                return hex.length === 1 ? "0" + hex : hex;
              })
              .join("")
      ).toUpperCase().replaceAll(".","");
    },

  componentToHex(c) {
  const hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
},
    getRandomColorWithinRange(hexColor) {
      const color = this.hexToRgb(hexColor);
      const random = Math.floor(Math.random() * 256);
      const max = Math.max(...color);
      const min = Math.min(...color);
      const range = max - min;
      const newColor = color.map((c) => {
        const newC = c + random - range / 2;
        return newC < 0 ? 0 : newC > 255 ? 255 : newC;
      });
      return this.rgbToHex(newColor[0], newColor[1], newColor[2]).toUpperCase();
},
    startAnimation() {
      var app=this;
      try{
        clearInterval(app.animation);
      }catch(err){

      }
      try{
        clearInterval(app.animate_mounted);
      }catch(err){

      }
      try{
        clearInterval(app.animate_change_colors_text);
      }catch(err){

      }
      // выбираем случайную анимацию из двух возможных
      this.animation = Math.random() < 0.5 ? "explode" : "build";
      // запускаем анимацию с интервалом в 5 секунд
    //  this.animate_mounted=setInterval(this.animateLogo, 5000);

      this.animate_change_colors_text=setInterval(this.animateChangeText,3000);
      //this.animateLogo();
    },
    animateChangeText(){
      var app=this;
      try{
        clearInterval(app.animation_interval);
      }catch (err){

      }
      app.runAnimation('change_colors');
    },
    animateColors(startColor, endColor) {



      const steps = 50;
      const interval = 30;
      let step = 0;
      const rStep = (parseInt(endColor.substring(1, 3), 16) - parseInt(startColor.substring(1, 3), 16)) / steps;
      const gStep = (parseInt(endColor.substring(3, 5), 16) - parseInt(startColor.substring(3, 5), 16)) / steps;
      const bStep = (parseInt(endColor.substring(5, 7), 16) - parseInt(startColor.substring(5, 7), 16)) / steps;
      const timer = setInterval(() => {
        if (step >= steps) {
          clearInterval(timer);
          return;
        }
        step++;
        const r = parseInt(startColor.substring(1, 3), 16) + rStep * step;
        const g = parseInt(startColor.substring(3, 5), 16) + gStep * step;
        const b = parseInt(startColor.substring(5, 7), 16) + bStep * step;
        this.logoStyle.background = `rgb(${r}, ${g}, ${b})`;
      }, interval);
    },
    getRandomColor() {
      const colors = this.colors;

      return colors[Math.floor(Math.random() * colors.length)];
    },
    startChangeText(){
      var app=this;
      var types=["begin","random"];
      let type = types[Math.floor(Math.random() * types.length)];

      var available_words=app.available_words;
      let current_word= available_words[Math.floor(Math.random() * available_words.length)];

      app.animation_interval=setInterval(   () => {

      app.methodChangeText("begin",current_word);
      }, 100);
     // app.methodChangeText();
    },
    compareLogos(new_logo, old_logo) {
  if (new_logo && old_logo && new_logo.length >= old_logo.length) {
    return new_logo;
  } else {
    let new_logo_lengthened = new_logo;
    let new_logo_remastered="";
    var i=0;
    // while(new_logo_lengthened[i] && (new_logo_remastered.length<old_logo.length)){
    //   var tmp_cur=new_logo_lengthened[i];
    //   new_logo_remastered+=new_logo_lengthened[i]+new_logo_lengthened[i];
    //   i++;
    // }
    // while (new_logo_lengthened.length < old_logo.length) {
    //   new_logo_remastered+=
    //   new_logo_lengthened += new_logo_lengthened;
    //
    // }
    //new_logo_lengthened = new_logo_lengthened.substring(0, old_logo.length);
    return new_logo;
  }
},
    methodChangeText(type,current_word){
      //current_word=current_word.toUpperCase();
      current_word=this.compareLogos(current_word,this.nameSite);
      const words = current_word.split(" ");


      if(type=="begin"){
        let newWords = [];
        for (let i = 0; i < words.length; i++) {
          let newLetters = [];
          for (let j = 0; j < words[i].length; j++) {
            newLetters.push(
                `<span style="color:${this.getRandomColor()}">${words[i][j]}</span>`
            );
          }
          newWords.push(newLetters.join(""));
        }
        this.title_text_show = newWords.join(" ");
      } else if(type=="random") {




        const reversedWords = current_word;
        let newWords = [];
        for (let i = reversedWords.length - 1; i >= 0; i--) {
          let newLetters = [];
          for (let j = reversedWords[i].length - 1; j >= 0; j--) {
            newLetters.push(
                `<span style="color:${this.getRandomColor()}">${reversedWords[i][j]}</span>`
            );
          }
          newWords.push(newLetters.join(""));
        }
        this.title_text_show = newWords.join(" ");
      }



    },
    runAnimation(start_animate,callback){
      var app=this;
      // try {
      //   clearInterval(app.animation_interval);
      // }catch(err){}


      if (start_animate === "explode") {
        // анимация разрушения логотипа
        this.logoStyle = {
          // меняем цвет текста на градиент от красного к черному

          background: "linear-gradient(to right, #00c6ff, #3BFC15)",
          color: "white",
          // меняем размер шрифта на меньший
          fontSize: "1.0em",
          // меняем прозрачность на нулевую
          height:'70px',
          weight:'100px',
          opacity: "0",
          // добавляем эффект разброса букв по разным направлениям
          transform: `translate(${Math.random() * 100 - 50}%, ${
              Math.random() * 100 - 50
          }%) rotate(${Math.random() * 360}deg)`
        };
        if(this.current_theme=='night_mode'){
          var start_color=this.getRandomColorWithinRange("#180707");
          var end_color=this.getRandomColorWithinRange("#FF0033");
          this.logoStyle.background=  "linear-gradient(to right, "+start_color+", "+end_color+")";

        }
        if(this.current_theme=='day_mode'){
          var start_color=this.getRandomColorWithinRange("#0055FF");
          var end_color=this.getRandomColorWithinRange("#3BFC15");
          this.logoStyle.background=  "linear-gradient(to right, "+start_color+", "+end_color+")";


        }
      } else if(start_animate === "build") {
        // анимация создания логотипа
        this.logoStyle = {
          // меняем цвет текста на градиент от зеленовато-желтого к белому
          color: "linear-gradient(to right, limegreen, yellow, white)",
          background: "linear-gradient(to left, #00c6ff, #3BFC15)",
          // меняем размер шрифта на больший
          fontSize: "0.5em",
          // меняем прозрачность на единичную
          opacity: "1",
          // сбрасываем эффект разброса букв
          transform: "none"
        };
        if(this.current_theme=='night_mode'){
          var start_color=this.getRandomColorWithinRange("#FF0033");
          var end_color=this.getRandomColorWithinRange("#180707");

          this.logoStyle.background=  "linear-gradient(to left, "+start_color+", "+end_color+")";


        }
        if(this.current_theme=='day_mode'){

          var start_color=this.getRandomColorWithinRange("#00c6ff");
          var end_color=this.getRandomColorWithinRange("#3BFC15");
          this.logoStyle.background=  "linear-gradient(to left, "+start_color+", "+end_color+")";

        }
      }else if(start_animate=="change_colors"){

        start_color=this.getRandomColorWithinRange("#ff0000");
        end_color=this.getRandomColorWithinRange("#10ff00");
        if(this.current_theme=='night_mode'){

          var start_color=this.getRandomColorWithinRange("#ffcf00");
          var end_color=this.getRandomColorWithinRange("#ff00f8");


        }

        var max_element=5;
        var i=0;
        var colors_array=[];
        var tmp_color=start_color;
        while(i<max_element){
         tmp_color=tmp_color;

          tmp_color=this.getRandomColorWithinRange(tmp_color);
          colors_array.push(tmp_color);
          i++;
        }
        i=0;
        tmp_color=end_color;
        while(i<max_element){
          tmp_color=tmp_color;
          tmp_color=this.getRandomColorWithinRange(tmp_color);
          colors_array.push(tmp_color);
          i++;
        }
        this.currentColorIndex =0;

        const startColor = colors_array[0];
        const endColor = colors_array[colors_array.length-1];
        this.colors=colors_array;
        var start_color_logo_background="#180707";
        var end_color_logo_background="#FF0033";
        var type_animations=["to right","to left"];
        let choosed_animations = type_animations[Math.floor(Math.random() * type_animations.length)];
        if(this.current_theme=='night_mode'){
           start_color_logo_background="#180707";
           end_color_logo_background="#FF0033";
          start_color_logo_background=this.getRandomColorWithinRange("#190033");
          end_color_logo_background=this.getRandomColorWithinRange("#CC0000");
          this.logoStyle.background=  "linear-gradient("+choosed_animations+", "+start_color_logo_background+", "+end_color_logo_background+")";

        }
        if(this.current_theme=='day_mode'){
          start_color_logo_background="#0055FF";
           end_color_logo_background="#3BFC15";
          this.logoStyle.background=  "linear-gradient("+choosed_animations+", "+start_color_logo_background+", "+end_color_logo_background+")";


        }



         if(colors_array.length>0){
           this.startChangeText();
        }

        //this.animateColors(startColor, endColor);


      }


    },
    animateLogo() {
      try{
        // clearInterval(app.animation_interval);
      }catch(err){

      }
    var  variants=["explode","build"];
      if(this.prev_animation_name){
        let indexToRemovePrev = variants.indexOf(start_animate);
        if (indexToRemovePrev > -1) {
          variants.splice(indexToRemove, 1);
        }

      }
      let start_animate = variants[Math.floor(Math.random() * variants.length)];
      let indexToRemove = variants.indexOf(start_animate);
      if (indexToRemove > -1) {
        variants.splice(indexToRemove, 1);
      }
      let next_animate =  variants[Math.floor(Math.random() * (variants.length))];
      if(this.prev_animation_name && this.prev_animation_name=='explode'){
        start_animate='build';
      }else if(this.prev_animation_name && this.prev_animation_name=='build'){
        start_animate='explode';
      }
      this.prev_animation_name=start_animate;

       var app=this;
      app.runAnimation(start_animate);




      // меняем тип анимации на противоположный


    }
  }
};
</script>

<style scoped>

</style>
